import React, { Component } from 'react';
import {connect} from 'react-redux';
import {List, Map} from "immutable";
import {Icon} from "@blueprintjs/core";
import Modal from "@atlaskit/modal-dialog/dist/esm/components/Modal";
import numeral from 'numeral';
import _ from 'lodash';

// Components
import VirtualizedTable from "../../components/common/virtualized-table";
import {projectTasks} from "../../components/common/project-tasks";
import EmployeeWorkReportsDialog from "../../components/dialogs/EmployeeWorkReportsDialog";

// Actions
import {getWorkReports, createWorkReports, deleteWorkReport, cleanWorkReports} from "../../actions/work-reports";
import {getProjects, cleanProjects} from "../../actions/projects";

// Numeral configuration
import 'numeral/locales/es-es'
numeral.locale('es-es');
numeral.defaultFormat('0,0.00 $');

class EmployeeWorkReports extends Component {
    constructor(props) {
        super(props);

        this.state = {
            canSubmit: false,
            modalIsOpen: false,
            modalType: null
        }
    }

    componentDidMount() {
        this.props.getWorkReports({
            filters: { employee: this.props.employee.get('_id') },
            projection: 'date project task hours cost',
            populateRefs: true
        });
        if (this.props.location.state && this.props.location.state.openNewWorkReport) {
            this.openModal('workReportsDialog');
        }
    }

    componentWillUnmount() {
        this.props.cleanWorkReports();
    }

    onCanSubmit = (canSubmit) => {
        this.setState({
            canSubmit
        });
    };

    // Modal Handlers
    openModal = (modalType) => {
        this.props.getProjects({
            filters: { status: 'active' },
            projection: 'project_code name'
        });
        this.setState({
            modalType,
            modalIsOpen: true
        });
    };
    closeModal = () => {
        this.setState({
            modalType: null,
            modalIsOpen: false,
            canSubmit: false
        }, this.props.cleanProjects)
    };

    render() {

        // Calc Total labour hours
        let total_labour_hours = 0;
        this.props.workReports.map( report => {
            return total_labour_hours = total_labour_hours + report.get('hours');
        });

        // Calc Total Cost
        let total_cost = 0;
        this.props.workReports.map( report => {
            return total_cost = total_cost + report.get('cost');
        });

        // Work Reports Table
        const tableData = this.props.workReports;
        const tableSettings = {
            showFooter: true,
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: tableData.size < 17 ? tableData.size * 40 : 680,
            rowHeight: 40,
            strippedRows: false,
        };
        const tableColumns = {
            date: {
                title: 'Fecha',
                columnType: 'date',
                dataField: 'date',
                width: 100,
                style: {},
                sortable: true,
                filterable: true,
                format: 'DD/MM/YYYY'
            },
            project: {
                title: "Proyecto",
                columnType: 'text',
                dataField: 'project.name',
                width: 200,
                style: {},
                sortable: true,
                filterable: true
            },
            task: {
                title: "Tarea",
                columnType: 'text',
                dataField: 'task',
                width: 200,
                style: {},
                sortable: true,
                filterable: true
            },
            hours: {
                title: "Horas",
                columnType: 'number',
                dataField: 'hours',
                width: 100,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                format: '0,0.00',
                footer: { type: 'operation', value: 'sum' }
            },
            cost: {
                title: "Coste (€)",
                columnType: 'number',
                dataField: 'cost',
                width: 100,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: '_id',
                width: 100,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (workReportId) => {
                    return (
                        <Icon className="cursor-pointer" icon="trash" title="Eliminar" onClick={() => {
                            this.props.deleteWorkReport(workReportId);
                        }} />
                    );
                }
            }
        };

        // Modal Area
        let modal = null;
        if (this.state.modalIsOpen) {
            switch (this.state.modalType) {
                case 'workReportsDialog':
                    modal = {
                        width: 'large',
                        title: 'Registrar trabajo',
                        body: (
                            <EmployeeWorkReportsDialog
                                onRef={ref => (this.child = ref)}
                                projects={this.props.projects}
                                employee={this.props.employee}
                                onCanSubmit={this.onCanSubmit}
                                onCloseModal={this.closeModal}
                                onSaveWorkReports={this.props.createWorkReports}
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="accept"
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={!this.state.canSubmit}
                                    onClick={ () => this.child.onSaveButtonClick() }
                                >
                                    {'Guardar'}
                                </button>
                            </div>
                        )
                    };
                    break;
                default:
                    modal = {
                        title: '',
                        body: null,
                        footer: null
                    };
                    break;
            }
        }

        return (
            <div className="panel-body">
                <div className="row stats-zone" style={{ margin: '10px 0' }} >
                    <div className="col-auto">
                        <span className="label label-primary">{_.uniq(tableData.map(workReport => workReport.getIn(['project', '_id'])).toJS()).length}</span>
                        <span>Proyectos</span>
                    </div>
                    <div className="col-auto">
                        <span className="label">{ _.round(total_labour_hours, 2) }</span>
                        <span>Total horas registradas</span>
                    </div>
                    <div className="col-auto">
                        <span className="label">{ numeral(total_cost).format() }</span>
                        <span>Total Coste</span>
                    </div>
                    <div className="col-auto ml-auto ">
                        <button
                            className="btn btn-primary"
                            onClick={ () => this.openModal('workReportsDialog') }
                        ><Icon icon="insert" />Registrar trabajo</button>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <VirtualizedTable
                            tableSettings={tableSettings}
                            tableColumns={tableColumns}
                            tableData={tableData}
                        />
                    </div>
                </div>
                { this.state.modalIsOpen && (
                    <Modal
                        width={modal.width}
                        heading={modal.title}
                        footer={() => modal.footer}
                        autoFocus={false}
                        onClose={this.closeModal}
                    >
                        {modal.body}
                    </Modal>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => {
    // Reducers
    const workReportsReducer = state.workReports;
    const projectsReducer = state.projects;

    // WorkReports
    let workReports = workReportsReducer.get('payload') || List([]);
    if (!(workReports instanceof List)) workReports = List([]);
    if (workReports.size > 0) {
        workReports = workReports.map(workReport => {
            const task = projectTasks.find(task => {
                return task.get('task_code') === workReport.get('task').toString()
            });
            const name = task && task.get('name');
            return workReport.set('task', name);
        });
    }

    // Projects
    let projects = projectsReducer.get('payload') || List([]);
    if (!(projects instanceof List)) projects = List([]);
    if (projects.size > 0) {
        projects = projects.map(project => project.set('select', `[${project.get('project_code')}] ${project.get('name')}`));
    }
    projects = projects.insert(0, Map({ _id: -1, select: 'Selecciona un proyecto' }));

    return {
        workReports,
        projects
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getWorkReports: query => dispatch(getWorkReports(query)),
        getProjects: query => dispatch(getProjects(query)),
        createWorkReports: (workReports, options) => dispatch(createWorkReports(workReports, options)),
        deleteWorkReport: workReportId => dispatch(deleteWorkReport(workReportId)),
        cleanWorkReports: () => dispatch(cleanWorkReports()),
        cleanProjects: () => dispatch(cleanProjects())
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(EmployeeWorkReports);


// WEBPACK FOOTER //
// ./src/containers/employees/EmployeeWorkReports.js